import React from "react";
import { useNavigate } from "react-router";

const SurveyClosedScreen = () => {
  const navigate = useNavigate();

  return (
    <>
      <h2 className="text-center">
        Lo sentimos, este formulario se encuentra cerrado. Ya no lo puedes contestar.
      </h2>
      <div className="text-center mt-4">
        <button onClick={() => navigate("/")} className="btn btn-primary btn-lg">
          Volver al inicio
        </button>
      </div>
    </>
  );
};

export default SurveyClosedScreen;
